module.exports = __webpack_public_path__ + "media/bootstrap-icons/basket3-bb67f7e9.svg";